import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ReviewWorking() {
  const { t } = useTranslation();
  const [started] = useState(() => Date.now());
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => { setSeconds(Math.floor((Date.now() - started) / 1000)); }, 1000);
    return () => { window.clearInterval(timer); };
  }, [started]);
  return <p role="status" className="app-text-muted text-sm">{t("importProposals.impact.working", { seconds })}</p>;
}
